module.exports = __webpack_public_path__ + "static/img/3.0b5e23b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/3.png
// module id = Be1p
// module chunks = 4